import { getFirstAuthorName, getPublicationYear, } from "./relatedProductDetails";
/**
 * Builds the option label of a related product in the product form
 * ("Související produkty" → "Číslo produktu"). Volumes of one multi-volume set
 * share title and form, so the formatted product numbers (ISBN/ISMN) go first
 * to tell them apart. Then "title - first author - year - form"; a missing part
 * is left out together with its separator.
 */
export var formatRelatedProductLabel = function (product, productNumbers) {
    var _a, _b, _c, _d;
    var base = [
        (_c = (_b = (_a = product.title) === null || _a === void 0 ? void 0 : _a.names) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.name,
        getFirstAuthorName(product),
        getPublicationYear(product),
        (_d = product.form) === null || _d === void 0 ? void 0 : _d.description,
    ]
        .filter(function (part) { return !!part; })
        .join(" - ");
    var numbers = (productNumbers || [])
        .map(function (productNumber) { return productNumber.fullFormattedValue; })
        .filter(function (value) { return !!value; })
        .join(", ");
    return [numbers, base].filter(Boolean).join(" – ");
};
